module.exports = __webpack_public_path__ + "static/media/backarrowwhite.017845de.svg";